import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import appConfig from '../../../config/env';
import images from '../../../helpers/images';
import helpers from '../../../helpers/helpers';

import { httpRequest } from '../../../helpers/httpService';

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

import EventCards from '../../parts/EventCards';

import Paginations from '../../parts/Paginations';
import Loader from '../../parts/Loader';
 
function HomePage (){
    const api_url = appConfig.apiUrl;
    const [upcoming_event_list, setEvents] = useState([]);
    const [calendar_event_list, setCalendarEvents] = useState([]);
    const [archive_event_list, setArchiveEvents] = useState([]);
    const [loading, setLoading] = useState(1);

    //let upcoming_event_list = [];
    let featured_archive_list = [];

    let navigate = useNavigate();
   
    useEffect(() => {
        getEvents();
        window.scrollTo(0,0);
    }, []);

    function getEvents() {
        setLoading(1)
        const url = api_url + '/public/events';

        // Upcoming Events
        httpRequest(url + '?filter=upcoming', "GET")
            .then((res) => {
                setEvents(res);
                setLoading(0)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)
            });

        // All active events for calendar
        httpRequest(url + '?paginate=0', "GET")
            .then((res) => {
                setCalendarEvents(res.data);
            })
            .catch((err) => {
                //console.log(err)
            });

        // fetured archive Events
        httpRequest(url + '?filter=archived&paginate=0', "GET")
            .then((res) => {
                setArchiveEvents(res.data);
            })
            .catch((err) => {
                //console.log(err)
            });
    }

    function eventClick(e){
        const id = e.event.id
        const slug = e.event.extendedProps.slug

        const target  = (slug) ? slug : id;
        //window.location.href = "/event";
        return navigate("/e/" + target);
    }

    function changePage(page) {
        let params = `page=${page}&filter=upcoming`

        // if(search_key!==''){
        //     params += '&' + search_filter+'='+search_key
        // }

       const url = `${api_url}/public/events?${params}`

        httpRequest(url, "GET")
            .then((res) => {
                setEvents(res);
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)
            });

        
        //sendRequest(url)
    }
    
    //Featured archive event
    if (archive_event_list && archive_event_list.length > 0) {
        let counter = 1;
        featured_archive_list = archive_event_list.map((data, i) => {

            return (
                <div className="col-lg-3 mb-3 d-flex align-items-stretch" key={i}>
                    <div className="card">
                        <img className="card-img-top" src={ helpers.getFileURL(data.image_thumbnail)} alt="Card image cap" />
                        <div className="card-body d-flex flex-column">
                            <h6 className="card-featured-date">{helpers.displayDateTime(data)}</h6>
                            <h4 className="card-featured-title mt-2">{data.title}</h4>
                            <p className="card-featured-text mt-4">{data.summary}</p>
                            <div className="card-location">
                                <img src={images.locationIcon} alt="location" className="locatioon_icon" />
                                {data.venue_type == 'physical' ? (
                                    <small className="mx-1">{data.address}</small>
                                ) : (
                                    <small className="mx-1">Online</small>
                                )}
                            </div>
                            
                            <div className="card-show-more mt-3">
                                <Link to={'/e/'+ ((data.slug) ? data.slug: data.id)} className="show-more-link"><small>Show more &gt;</small></Link>
                            </div>
                        </div>
                    </div>
                </div>
            )
        });
    }

    return (
        <>
        <div id="intro-example" className="p-5 text-center bg-image"></div>

        <section className="container calendar_section" style={{position: 'relative'}}>
            <Loader isLoading={loading} backgroundColor='white'/>
            <div className="container my-5">
                <div className="row">
                    <div className="col-md-9">
                    <h2 className="mt-4 mb-4 home-title">Upcoming Events</h2>
                    </div>
                    <div className="col-3">
                    <div className="dropdown mt-4 d-flex justify-content-end">
                        <div className="input-group">
                        <select className="form-select" aria-label="Filter select" defaultValue={0}>
                            <option value={0}>⧩ Date</option>
                            <option value={1}>Month</option>
                            <option value={2}>Day</option>
                            <option value={3}>Year</option>
                        </select>
                        </div>
                    </div>
                    </div>
                </div>

                <EventCards data={upcoming_event_list.data}  empty_caption="No upcoming event." />

                <Paginations
                    current_page={upcoming_event_list.current_page}
                    total_page={upcoming_event_list.total}
                    per_page={upcoming_event_list.per_page}
                    changePage={changePage}
                    showAlways={false}
                />
            </div>
        </section>

        <section className="container calendar_section">
        <div className="container my-5">
            <div className="row">
            <div className="col-md-9">
                <h2 className="mt-4 mb-4 home-title">Calendar View</h2>
            </div>
            <div className="col-3">
                {/* <div className="dropdown mt-4 d-flex justify-content-end">
                    <div className="input-group">
                        <select className="form-select" aria-label="Filter select" defaultValue={0}>
                        <option value={0}>⧩ Date</option>
                        <option value={1}>Month</option>
                        <option value={2}>Day</option>
                        <option value={3}>Year</option>
                        </select>
                    </div>
                </div> */}
            </div>
            <div className="col-md-12">
            <FullCalendar
                headerToolbar={{
                    left: 'prev',
                    center: 'title',
                    right: 'next'
                }}
                plugins={[ dayGridPlugin ]}
                initialView="dayGridMonth"
                events = {calendar_event_list}
                eventClick = {(e) => eventClick(e)}
            />
            </div>
            </div>
        </div>
        </section>

        {/* Start of Featured Events */}

        {
            Object.entries(archive_event_list).length > 0 && 
            <section className="feature-background">
                <div className="container">
                    <div className="row pt-5">
                    <div className="col-12">
                        <h2 className="mt-4 mb-4 home-title">Featured Previous Events</h2>
                    </div>
                    </div>
                    <div className="row">
    
                        {featured_archive_list}
    
                    </div>
                </div>
            </section>
        }
        </>
    )
}
 
export default HomePage;